export const LeftArrow = ({ height, width, color }) => {
  return (
    <svg
      width={width || 8}
      height={height || 12}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 1L1.5 6L6.5 11"
        stroke={color || "#4D4F50"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Minus = ({ height, width, color }) => {
  return (
    <svg
      width={width || 17}
      height={height || 16}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.43359 8H12.7669"
        stroke={color || "#ABB2B3"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Plus = ({ height, width, color }) => {
  return (
    <svg
      width={width || 17}
      height={height || 16}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.09961 3.33203V12.6654"
        stroke={color || "#ABB2B3"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.43359 8H12.7669"
        stroke={color || "#ABB2B3"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Business = ({ height, width, color }) => {
  return (
    <svg
      width={width || "26"}
      height={height || "25"}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9170_24894"
        maskUnits="userSpaceOnUse"
        x="4"
        y="5"
        width="18"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3568 15.785V14.9637H5.61568L5.60747 18.249C5.60747 19.1607 6.33845 19.8917 7.25013 19.8917H18.7488C19.6605 19.8917 20.3915 19.1607 20.3915 18.249V14.9637H14.6421V15.785H11.3568V15.785ZM19.5701 8.393H16.2766V6.75033L14.6339 5.10767H11.3486L9.70592 6.75033V8.393H6.4288C5.52533 8.393 4.78613 9.1322 4.78613 10.0357V12.4997C4.78613 13.4113 5.51712 14.1423 6.4288 14.1423H11.3568V12.4997H14.6421V14.1423H19.5701C20.4736 14.1423 21.2128 13.4031 21.2128 12.4997V10.0357C21.2128 9.1322 20.4736 8.393 19.5701 8.393V8.393ZM14.6421 8.393H11.3568V6.75033H14.6421V8.393V8.393Z"
          fill={color || "white"}
        />
      </mask>
      <g mask="url(#mask0_9170_24894)">
        <rect
          x="2.32227"
          y="1.82227"
          width="21.3547"
          height="21.3547"
          fill={color || "white"}
        />
      </g>
    </svg>
  );
};

export const Package = ({ height, width, color }) => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.625 5.48331L4.375 2.45581"
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 9.33344V4.66677C12.2498 4.46218 12.1958 4.26124 12.0934 4.08412C11.991 3.90699 11.8438 3.7599 11.6667 3.65761L7.58333 1.32427C7.40598 1.22188 7.20479 1.16797 7 1.16797C6.79521 1.16797 6.59402 1.22188 6.41667 1.32427L2.33333 3.65761C2.15615 3.7599 2.00899 3.90699 1.9066 4.08412C1.80422 4.26124 1.75021 4.46218 1.75 4.66677V9.33344C1.75021 9.53803 1.80422 9.73897 1.9066 9.91609C2.00899 10.0932 2.15615 10.2403 2.33333 10.3426L6.41667 12.6759C6.59402 12.7783 6.79521 12.8322 7 12.8322C7.20479 12.8322 7.40598 12.7783 7.58333 12.6759L11.6667 10.3426C11.8438 10.2403 11.991 10.0932 12.0934 9.91609C12.1958 9.73897 12.2498 9.53803 12.25 9.33344Z"
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.9082 4.06006L7.0007 7.00589L12.0932 4.06006"
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 12.88V7"
        stroke="#FDFDFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Location = ({ height, width, color }) => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1864 1.73431C10.068 0.615919 8.58105 0 6.99943 0C5.41781 0 3.9308 0.615919 2.81243 1.73431C1.69404 2.85272 1.07812 4.33968 1.07812 5.92127C1.07812 9.12083 4.10339 11.7821 5.72868 13.2118C5.95454 13.4104 6.14958 13.582 6.30498 13.7272C6.49966 13.909 6.74956 14 6.9994 14C7.24929 14 7.49913 13.909 7.69385 13.7272C7.84924 13.582 8.04429 13.4104 8.27015 13.2118C9.89544 11.782 12.9207 9.12083 12.9207 5.92127C12.9207 4.33968 12.3048 2.85272 11.1864 1.73431ZM7.72847 12.596C7.49766 12.7991 7.29835 12.9744 7.13401 13.1279C7.05852 13.1984 6.94028 13.1984 6.86476 13.1279C6.70045 12.9744 6.50111 12.799 6.2703 12.596C4.74233 11.2519 1.89817 8.74999 1.89817 5.9213C1.89817 3.1085 4.18654 0.820123 6.99937 0.820123C9.81217 0.820123 12.1006 3.1085 12.1006 5.9213C12.1006 8.74999 9.25644 11.2519 7.72847 12.596Z"
        fill="white"
      />
      <path
        d="M7.00007 3.08984C5.56121 3.08984 4.39062 4.2604 4.39062 5.69926C4.39062 7.13812 5.56121 8.30868 7.00007 8.30868C8.43893 8.30868 9.60949 7.13812 9.60949 5.69926C9.60949 4.2604 8.43893 3.08984 7.00007 3.08984ZM7.00007 7.48856C6.01343 7.48856 5.21072 6.68585 5.21072 5.69924C5.21072 4.71262 6.01343 3.90991 7.00007 3.90991C7.98672 3.90991 8.78939 4.71262 8.78939 5.69924C8.78939 6.68585 7.98672 7.48856 7.00007 7.48856Z"
        fill="white"
      />
    </svg>
  );
};

export const PencilIcon = ({ height, width, color }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10H10.5"
        stroke="#7D63EC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 1.74999C8.44891 1.55108 8.7187 1.43933 9 1.43933C9.13929 1.43933 9.27721 1.46677 9.4059 1.52007C9.53458 1.57337 9.65151 1.6515 9.75 1.74999C9.84849 1.84848 9.92662 1.96541 9.97992 2.09409C10.0332 2.22278 10.0607 2.3607 10.0607 2.49999C10.0607 2.63928 10.0332 2.7772 9.97992 2.90589C9.92662 3.03457 9.84849 3.1515 9.75 3.24999L3.5 9.49999L1.5 9.99999L2 7.99999L8.25 1.74999Z"
        stroke="#7D63EC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InfoCircle = ({ height, width, color }) => {
  return (
    <svg
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15642_212137)">
        <path
          d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
          stroke={color || "#58596B"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12V9"
          stroke={color || "#58596B"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 6H9.0075"
          stroke={color || "#58596B"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15642_212137">
          <rect width={width || "18"} height={height || "18"} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AlertTriangle = ({ height, width, color }) => {
  return (
    <svg
      width={width || "18"}
      height={height || "18"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7257 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7257 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48883 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
        fill={color || "#F2AE34"}
        stroke={color || "#F2AE34"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.75V9.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.75H9.0075"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GuestAutoCompleteUserIcon = ({ height, width, color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clipPath="url(#clip0_9170_114305)">
        <path
          d="M15.501 11.5796C13.1962 10.8268 12.2381 9.89062 12.2381 9.89062L12.161 9.96416C11.4765 10.6084 10.7195 10.9871 10.0298 10.9871H9.96476C9.27516 10.9871 8.51815 10.6084 7.83368 9.96416L7.7565 9.89062C7.7565 9.89062 6.79849 10.8268 4.4936 11.5796C1.0912 12.8507 2.11281 18.0232 2.11183 18.0633C2.21899 18.6393 2.28145 18.8373 2.33587 18.8596C5.75263 20.3807 14.242 20.3807 17.6588 18.8596C17.7133 18.8373 17.7757 18.6393 17.8829 18.0633C17.8819 18.0232 18.9172 12.8712 15.501 11.5796Z"
          fill="#9698D6"
        />
        <path
          d="M13.5702 4.98037L13.5417 4.9494C13.3502 4.77412 13.3652 4.78417 13.3652 4.78417C13.3652 4.78417 13.6991 3.09933 13.4314 2.30257C13.011 1.03014 10.5001 0.177319 9.99651 0.0781964C9.99659 0.0772532 9.6902 0.0159422 9.67064 0.0158192C9.67064 0.0158192 9.27452 -0.0642746 8.8154 0.13598C8.5164 0.251015 6.95319 0.959885 6.5095 2.30257C6.24178 3.09933 6.57569 4.78417 6.57569 4.78417C6.57569 4.78417 6.59066 4.77412 6.39918 4.9494L6.37068 4.98037C6.24116 5.12743 6.27315 5.58757 6.41472 6.06629C6.543 6.54591 6.7102 6.6748 6.75027 6.78713C7.1564 8.694 8.5686 10.3221 10.0077 10.3221C11.4468 10.3221 12.7844 8.694 13.1905 6.78713C13.2307 6.67484 13.3979 6.54591 13.5261 6.06629C13.6677 5.58753 13.7034 5.09581 13.5702 4.98037Z"
          fill="#9698D6"
        />
      </g>
      <defs>
        <clipPath id="clip0_9170_114305">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Delete = ({ height, width, color }) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44416 11.6143C4.44416 12.2661 4.97749 12.7995 5.62934 12.7995H10.3701C11.0219 12.7995 11.5553 12.2661 11.5553 11.6143V5.68837C11.5553 5.03652 11.0219 4.50318 10.3701 4.50318H5.62934C4.97749 4.50318 4.44416 5.03652 4.44416 5.68837V11.6143ZM11.5553 2.72541H10.0738L9.65304 2.30466C9.54638 2.198 9.3923 2.13281 9.23823 2.13281H6.76119C6.60712 2.13281 6.45304 2.198 6.34638 2.30466L5.92564 2.72541H4.44416C4.11823 2.72541 3.85156 2.99207 3.85156 3.318C3.85156 3.64392 4.11823 3.91059 4.44416 3.91059H11.5553C11.8812 3.91059 12.1479 3.64392 12.1479 3.318C12.1479 2.99207 11.8812 2.72541 11.5553 2.72541Z"
        fill={color || "#EB5E5E"}
      />
    </svg>
  );
};

export const DeleteOutline = ({ height, width, color }) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 4H3.33333H14" fill="#888888" />
      <path
        d="M2 4H3.33333H14"
        stroke={color || "#A2A2B1"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 3.99998V2.66665C5.33398 2.31302 5.47446 1.97389 5.72451 1.72384C5.97456 1.47379 6.3137 1.33331 6.66732 1.33331H9.33398C9.68761 1.33331 10.0267 1.47379 10.2768 1.72384C10.5268 1.97389 10.6673 2.31302 10.6673 2.66665V3.99998M12.6673 3.99998V13.3333C12.6673 13.6869 12.5268 14.0261 12.2768 14.2761C12.0267 14.5262 11.6876 14.6666 11.334 14.6666H4.66732C4.3137 14.6666 3.97456 14.5262 3.72451 14.2761C3.47446 14.0261 3.33398 13.6869 3.33398 13.3333V3.99998H12.6673Z"
        stroke={color || "#A2A2B1"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 7.33331V11.3333"
        stroke={color || "#A2A2B1"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 7.33331V11.3333"
        stroke={color || "#A2A2B1"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 2.66406H3.33333C2.59695 2.66406 2 3.26102 2 3.9974V13.3307C2 14.0671 2.59695 14.6641 3.33333 14.6641H12.6667C13.403 14.6641 14 14.0671 14 13.3307V3.9974C14 3.26102 13.403 2.66406 12.6667 2.66406Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 1.33594V4.0026"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 1.33594V4.0026"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66406H14"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AllPackageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FBFAFD" />
      <path
        d="M14.25 10.7005L9.75 8.10547"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 13.999V9.99897C16.4998 9.82361 16.4535 9.65138 16.3658 9.49956C16.278 9.34773 16.1519 9.22166 16 9.13397L12.5 7.13397C12.348 7.04621 12.1755 7 12 7C11.8245 7 11.652 7.04621 11.5 7.13397L8 9.13397C7.84813 9.22166 7.72199 9.34773 7.63423 9.49956C7.54647 9.65138 7.50018 9.82361 7.5 9.99897V13.999C7.50018 14.1743 7.54647 14.3466 7.63423 14.4984C7.72199 14.6502 7.84813 14.7763 8 14.864L11.5 16.864C11.652 16.9517 11.8245 16.9979 12 16.9979C12.1755 16.9979 12.348 16.9517 12.5 16.864L16 14.864C16.1519 14.7763 16.278 14.6502 16.3658 14.4984C16.4535 14.3466 16.4998 14.1743 16.5 13.999Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.63477 9.48047L11.9998 12.0055L16.3648 9.48047"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.04V12"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ViewMenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FBFAFD" />
      <g clipPath="url(#clip0_2130_151469)">
        <path
          d="M6.5 9V17L10 15L14 17L17.5 15V7L14 9L10 7L6.5 9Z"
          stroke="#8181A5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 7V15"
          stroke="#8181A5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 9V17"
          stroke="#8181A5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2130_151469">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeletePackageIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FBFAFD" />
      <path
        d="M7.5 9H8.5H16.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9V8C10 7.73478 10.1054 7.48043 10.2929 7.29289C10.4804 7.10536 10.7348 7 11 7H13C13.2652 7 13.5196 7.10536 13.7071 7.29289C13.8946 7.48043 14 7.73478 14 8V9M15.5 9V16C15.5 16.2652 15.3946 16.5196 15.2071 16.7071C15.0196 16.8946 14.7652 17 14.5 17H9.5C9.23478 17 8.98043 16.8946 8.79289 16.7071C8.60536 16.5196 8.5 16.2652 8.5 16V9H15.5Z"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11.5V14.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 11.5V14.5"
        stroke="#8181A5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Rupee = ({ color = "#D7DEDF" }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="rupee">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.13659 3.76085C9.03579 3.75092 8.90717 3.75001 8.54102 3.75001H5.16604C4.75182 3.75001 4.41604 3.41422 4.41604 3.00001C4.41604 2.58579 4.75182 2.25001 5.16604 2.25001H8.54102C8.55572 2.25001 8.57019 2.25001 8.58444 2.25C8.61234 2.25 8.63942 2.25 8.66574 2.25001H14.166C14.5802 2.25001 14.916 2.58579 14.916 3.00001C14.916 3.41422 14.5802 3.75001 14.166 3.75001H11.9162C12.2432 4.1857 12.4776 4.69531 12.5904 5.25001H14.166C14.5802 5.25001 14.916 5.58579 14.916 6.00001C14.916 6.41422 14.5802 6.75001 14.166 6.75001H12.6648C12.6631 6.89125 12.6587 7.00872 12.648 7.11757C12.4726 8.898 11.064 10.3066 9.28359 10.4819C9.09962 10.5001 8.89089 10.5001 8.58444 10.5C8.57019 10.5 8.55572 10.5 8.54102 10.5H6.9767L10.9463 14.4697C11.2393 14.7626 11.2393 15.2374 10.9463 15.5303C10.6535 15.8232 10.1786 15.8232 9.88569 15.5303L4.63571 10.2803C4.42121 10.0658 4.35704 9.74325 4.47313 9.46298C4.58921 9.18278 4.86269 9 5.16604 9H8.54102C8.90717 9 9.03579 8.9991 9.13659 8.9892C10.2048 8.88398 11.05 8.0388 11.1552 6.97054C11.1605 6.91615 11.1633 6.85363 11.1647 6.75001H5.91604C5.50182 6.75001 5.16604 6.41422 5.16604 6.00001C5.16604 5.58579 5.50182 5.25001 5.91604 5.25001H11.0376C10.7522 4.44204 10.0208 3.84794 9.13659 3.76085Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const Percentage = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 3.75L3.75 14.25"
        stroke="#D7DEDF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 6.75C5.91053 6.75 6.75 5.91053 6.75 4.875C6.75 3.83947 5.91053 3 4.875 3C3.83947 3 3 3.83947 3 4.875C3 5.91053 3.83947 6.75 4.875 6.75Z"
        stroke="#D7DEDF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 15C14.1605 15 15 14.1605 15 13.125C15 12.0895 14.1605 11.25 13.125 11.25C12.0895 11.25 11.25 12.0895 11.25 13.125C11.25 14.1605 12.0895 15 13.125 15Z"
        stroke="#D7DEDF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SingleSlotCalender = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.203125" width="20" height="20" rx="4" fill="white" />
      <path
        d="M6.66699 4.20312H4.33366C4.15685 4.20312 3.98728 4.27336 3.86225 4.39839C3.73723 4.52341 3.66699 4.69298 3.66699 4.86979V7.20312C3.66699 7.37994 3.73723 7.54951 3.86225 7.67453C3.98728 7.79955 4.15685 7.86979 4.33366 7.86979H6.66699C6.8438 7.86979 7.01337 7.79955 7.1384 7.67453C7.26342 7.54951 7.33366 7.37994 7.33366 7.20312V4.86979C7.33366 4.69298 7.26342 4.52341 7.1384 4.39839C7.01337 4.27336 6.8438 4.20313 6.66699 4.20312ZM6.66699 7.20312H4.33366V4.86979H6.66699V7.20312ZM15.667 4.20312H8.66699C8.49018 4.20312 8.32061 4.27336 8.19559 4.39839C8.07056 4.52341 8.00033 4.69298 8.00033 4.86979V7.20312C8.00033 7.37994 8.07056 7.54951 8.19559 7.67453C8.32061 7.79955 8.49018 7.86979 8.66699 7.86979H15.667C15.8438 7.86979 16.0134 7.79955 16.1384 7.67453C16.2634 7.54951 16.3337 7.37994 16.3337 7.20312V4.86979C16.3337 4.69298 16.2634 4.52341 16.1384 4.39839C16.0134 4.27336 15.8438 4.20313 15.667 4.20312ZM15.667 7.20312H8.66699V4.86979H15.667V7.20312ZM6.66699 8.53646H4.33366C4.15685 8.53646 3.98728 8.6067 3.86225 8.73172C3.73723 8.85675 3.66699 9.02631 3.66699 9.20312V11.5365C3.66699 11.7133 3.73723 11.8828 3.86225 12.0079C3.98728 12.1329 4.15685 12.2031 4.33366 12.2031H6.66699C6.8438 12.2031 7.01337 12.1329 7.1384 12.0079C7.26342 11.8828 7.33366 11.7133 7.33366 11.5365V9.20312C7.33366 9.02631 7.26342 8.85675 7.1384 8.73172C7.01337 8.6067 6.8438 8.53646 6.66699 8.53646ZM6.66699 11.5365H4.33366V9.20312H6.66699V11.5365ZM15.667 8.53646H8.66699C8.49018 8.53646 8.32061 8.6067 8.19559 8.73172C8.07056 8.85675 8.00033 9.02631 8.00033 9.20312V11.5365C8.00033 11.7133 8.07056 11.8828 8.19559 12.0079C8.32061 12.1329 8.49018 12.2031 8.66699 12.2031H15.667C15.8438 12.2031 16.0134 12.1329 16.1384 12.0079C16.2634 11.8828 16.3337 11.7133 16.3337 11.5365V9.20312C16.3337 9.02631 16.2634 8.85675 16.1384 8.73172C16.0134 8.6067 15.8438 8.53646 15.667 8.53646ZM15.667 11.5365H8.66699V9.20312H15.667V11.5365ZM6.66699 12.8698H4.33366C4.15685 12.8698 3.98728 12.94 3.86225 13.0651C3.73723 13.1901 3.66699 13.3596 3.66699 13.5365V15.8698C3.66699 16.0466 3.73723 16.2162 3.86225 16.3412C3.98728 16.4662 4.15685 16.5365 4.33366 16.5365H6.66699C6.8438 16.5365 7.01337 16.4662 7.1384 16.3412C7.26342 16.2162 7.33366 16.0466 7.33366 15.8698V13.5365C7.33366 13.3596 7.26342 13.1901 7.1384 13.0651C7.01337 12.94 6.8438 12.8698 6.66699 12.8698ZM6.66699 15.8698H4.33366V13.5365H6.66699V15.8698ZM15.667 12.8698H8.66699C8.49018 12.8698 8.32061 12.94 8.19559 13.0651C8.07056 13.1901 8.00033 13.3596 8.00033 13.5365V15.8698C8.00033 16.0466 8.07056 16.2162 8.19559 16.3412C8.32061 16.4662 8.49018 16.5365 8.66699 16.5365H15.667C15.8438 16.5365 16.0134 16.4662 16.1384 16.3412C16.2634 16.2162 16.3337 16.0466 16.3337 15.8698V13.5365C16.3337 13.3596 16.2634 13.1901 16.1384 13.0651C16.0134 12.94 15.8438 12.8698 15.667 12.8698ZM15.667 15.8698H8.66699V13.5365H15.667V15.8698Z"
        fill="#A384FF"
      />
    </svg>
  );
};

export const MultiSlotCalender = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.601562" width="20" height="20" rx="4" fill="white" />
      <path
        d="M6.89305 4.42969H4.47694C4.29386 4.42969 4.11827 4.50242 3.98881 4.63188C3.85935 4.76134 3.78662 4.93692 3.78662 5.12001V7.53612C3.78662 7.7192 3.85935 7.89479 3.98881 8.02425C4.11827 8.15371 4.29386 8.22644 4.47694 8.22644H6.89305C7.07614 8.22644 7.25172 8.15371 7.38118 8.02425C7.51064 7.89479 7.58337 7.7192 7.58337 7.53612V5.12001C7.58337 4.93692 7.51064 4.76134 7.38118 4.63188C7.25172 4.50242 7.07614 4.42969 6.89305 4.42969ZM6.89305 7.53612H4.47694V5.12001H6.89305V7.53612ZM16.2124 4.42969H8.96401C8.78093 4.42969 8.60534 4.50242 8.47588 4.63188C8.34642 4.76134 8.27369 4.93692 8.27369 5.12001V7.53612C8.27369 7.7192 8.34642 7.89479 8.47588 8.02425C8.60534 8.15371 8.78093 8.22644 8.96401 8.22644H16.2124C16.3954 8.22644 16.571 8.15371 16.7005 8.02425C16.8299 7.89479 16.9027 7.7192 16.9027 7.53612V5.12001C16.9027 4.93692 16.8299 4.76134 16.7005 4.63188C16.571 4.50242 16.3954 4.42969 16.2124 4.42969ZM16.2124 7.53612H8.96401V5.12001H16.2124V7.53612Z"
        fill="#EDE7FF"
      />
      <path
        d="M6.99071 8.92969H4.5746C4.39151 8.92969 4.21593 9.00242 4.08647 9.13188C3.95701 9.26134 3.88428 9.43692 3.88428 9.62001V12.0361C3.88428 12.2192 3.95701 12.3948 4.08647 12.5242C4.21593 12.6537 4.39151 12.7264 4.5746 12.7264H6.99071C7.17379 12.7264 7.34938 12.6537 7.47884 12.5242C7.6083 12.3948 7.68103 12.2192 7.68103 12.0361V9.62001C7.68103 9.43692 7.6083 9.26134 7.47884 9.13188C7.34938 9.00242 7.17379 8.92969 6.99071 8.92969ZM6.99071 12.0361H4.5746V9.62001H6.99071V12.0361ZM16.31 8.92969H9.06167C8.87858 8.92969 8.703 9.00242 8.57354 9.13188C8.44408 9.26134 8.37135 9.43692 8.37135 9.62001V12.0361C8.37135 12.2192 8.44408 12.3948 8.57354 12.5242C8.703 12.6537 8.87858 12.7264 9.06167 12.7264H16.31C16.4931 12.7264 16.6687 12.6537 16.7981 12.5242C16.9276 12.3948 17.0003 12.2192 17.0003 12.0361V9.62001C17.0003 9.43692 16.9276 9.26134 16.7981 9.13188C16.6687 9.00242 16.4931 8.92969 16.31 8.92969ZM16.31 12.0361H9.06167V9.62001H16.31V12.0361Z"
        fill="#A384FF"
      />
      <path
        d="M6.99071 13.4297H4.5746C4.39151 13.4297 4.21593 13.5024 4.08647 13.6319C3.95701 13.7613 3.88428 13.9369 3.88428 14.12V16.5361C3.88428 16.7192 3.95701 16.8948 4.08647 17.0242C4.21593 17.1537 4.39151 17.2264 4.5746 17.2264H6.99071C7.17379 17.2264 7.34938 17.1537 7.47884 17.0242C7.6083 16.8948 7.68103 16.7192 7.68103 16.5361V14.12C7.68103 13.9369 7.6083 13.7613 7.47884 13.6319C7.34938 13.5024 7.17379 13.4297 6.99071 13.4297ZM6.99071 16.5361H4.5746V14.12H6.99071V16.5361ZM16.31 13.4297H9.06167C8.87858 13.4297 8.703 13.5024 8.57354 13.6319C8.44408 13.7613 8.37135 13.9369 8.37135 14.12V16.5361C8.37135 16.7192 8.44408 16.8948 8.57354 17.0242C8.703 17.1537 8.87858 17.2264 9.06167 17.2264H16.31C16.4931 17.2264 16.6687 17.1537 16.7981 17.0242C16.9276 16.8948 17.0003 16.7192 17.0003 16.5361V14.12C17.0003 13.9369 16.9276 13.7613 16.7981 13.6319C16.6687 13.5024 16.4931 13.4297 16.31 13.4297ZM16.31 16.5361H9.06167V14.12H16.31V16.5361Z"
        fill="#EDE7FF"
      />
    </svg>
  );
};

export const DeleteIconPayment = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="4" fill="#FDFDFE" />
      <g clipPath="url(#clip0_9170_134315)">
        <path
          d="M7.25 8.5H8.08333H14.75"
          stroke="#EB5E5E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33398 8.50065V7.66732C9.33398 7.4463 9.42178 7.23434 9.57806 7.07806C9.73434 6.92178 9.9463 6.83398 10.1673 6.83398H11.834C12.055 6.83398 12.267 6.92178 12.4232 7.07806C12.5795 7.23434 12.6673 7.4463 12.6673 7.66732V8.50065M13.9173 8.50065V14.334C13.9173 14.555 13.8295 14.767 13.6732 14.9232C13.517 15.0795 13.305 15.1673 13.084 15.1673H8.91732C8.6963 15.1673 8.48434 15.0795 8.32806 14.9232C8.17178 14.767 8.08398 14.555 8.08398 14.334V8.50065H13.9173Z"
          stroke="#EB5E5E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.166 10.584V13.084"
          stroke="#EB5E5E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.834 10.584V13.084"
          stroke="#EB5E5E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9170_134315">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeftArrowCalender = () => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.31641 12.7109L6.86328 12.1914C6.97266 12.0547 6.97266 11.8359 6.86328 11.7266L1.91406 6.75L6.86328 1.80078C6.97266 1.69141 6.97266 1.47266 6.86328 1.33594L6.31641 0.816406C6.17969 0.679688 5.98828 0.679688 5.85156 0.816406L0.109375 6.53125C0 6.66797 0 6.85938 0.109375 6.99609L5.85156 12.7109C5.98828 12.8477 6.17969 12.8477 6.31641 12.7109Z"
        fill="#58596B"
      />
    </svg>
  );
};

export const RightArrowCalender = () => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.65625 0.816406L0.109375 1.33594C0 1.47266 0 1.69141 0.109375 1.80078L5.05859 6.75L0.109375 11.7266C0 11.8359 0 12.0547 0.109375 12.1914L0.65625 12.7109C0.792969 12.8477 0.984375 12.8477 1.12109 12.7109L6.86328 6.99609C6.97266 6.85938 6.97266 6.66797 6.86328 6.53125L1.12109 0.816406C0.984375 0.679688 0.792969 0.679688 0.65625 0.816406Z"
        fill="#58596B"
      />
    </svg>
  );
};

export const RevenueTag = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.295 6.705L6.71 10.29C6.61713 10.383 6.50684 10.4567 6.38544 10.5071C6.26404 10.5574 6.13392 10.5833 6.0025 10.5833C5.87108 10.5833 5.74096 10.5574 5.61956 10.5071C5.49816 10.4567 5.38787 10.383 5.295 10.29L1 6V1H6L10.295 5.295C10.4813 5.48236 10.5858 5.73581 10.5858 6C10.5858 6.26419 10.4813 6.51764 10.295 6.705Z"
        fill="#7D63EC"
      />
      <path
        d="M3.5 3.5H3.505"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
